import { Theme } from "@mui/material";
import { SystemStyleObject } from "@mui/system";

export const sliderRail: SystemStyleObject = {
  backgroundColor: "#d3d3d338",
  opacity: 1,
  position: "relative",
};
export const bufferProgress: SystemStyleObject = {
  content: "''",
  height: "100%",
  left: 0,
  backgroundColor: "#D3D3D3",
  borderRadius: "inherit",
  position: "absolute",
  transition: "width 0.2s ease",
};

export const classes: Record<string, SystemStyleObject<Theme>> = {
  actionsBar: {
    display: "flex",
    padding: { sm: "8px 48px", xs: "8px 16px" },
    borderRadius: "8px",
    background: "rgba(12, 12, 12, 0.82)",
    backdropFilter: "blur(4px)",
    height: "56px",
  },

  actions: {
    flex: 1,
    display: "flex",
    alignItems: "center",
  },

  controlIcon: {
    color: "white",

    "&.mute-btn": {
      "&:hover": {
        "+.volume": {
          width: "100px",
        },
      },
    },
  },

  volume: {
    width: "0px",
    height: "100%",
    display: "flex",
    alignItems: "center",
    padding: "0px 20px 0px 0px",
    transition: "all 0.3s ease",

    "&:hover": {
      width: "100px",
    },
  },

  timeBox: {
    display: "flex",
    alignItems: "center",
    flex: 1,
  },

  controlsWrapper: {
    position: "absolute",
    bottom: { sm: "30px", xs: "20px" },
    width: "95%",
    transition: "all 0.3s ease-in-out",
    zIndex: 3,
    transform: "translateY(150%)",
    opacity: 0,
    left: 0,
    right: 0,
    marginLeft: "auto",
    marginRight: "auto",
  },

  progressBar: {
    padding: "4px 0 !important",
    height: "6px",
    ".MuiSlider-thumb": {
      transition: "0.1s ease-in",
      transform: "translate(-50%, -50%) scale(0)",
    },
    ".MuiSlider-rail": {
      backgroundColor: "#D3D3D3",
      opacity: 1,
    },

    "&:hover": {
      ".MuiSlider-thumb": {
        transform: "translate(-50%, -50%) scale(1)",
      },

      height: "6px",
    },
  },
};
